import { useMeQuery, useWorkspaceDirectoryQuery } from '@platform/state/api';
import type { IWorkspaceRow } from './IWorkspaceRow';
import type { IWorkspaceRows } from './IWorkspaceRows';

/**
 * Робочі простори платформи для «Адміністрування» (прототип v4 adm-ws, KPI «Робочі простори · N ваших»): каталог GET /workspaces/directory
 * (усі простори з учасниками, модулями й моєю роллю — у порядку сервера, тобто прототипу s.workspaces: за створенням); сервер без каталогу —
 * лише мої простори з GET /me.
 */
export function useWorkspaceRows(): IWorkspaceRows {
  const { data: me } = useMeQuery();
  const { data: dir } = useWorkspaceDirectoryQuery();
  if (dir?.available) {
    const rows: IWorkspaceRow[] = dir.items.map((w) => ({ id: w.id, name: w.name, type: w.type, members: w.members, modules: w.modules, role: w.myRole }));
    return { rows, directory: true, mine: rows.filter((r) => r.role).length };
  }
  const rows = (me?.workspaces ?? []).map((w): IWorkspaceRow => ({ id: w.id, name: w.name, type: w.type, members: null, modules: null, role: w.myRole }));
  return { rows, directory: false, mine: rows.length };
}
